<template>
  <v-app-bar absolute color="#C0D7E4">
    <v-toolbar-title style="overflow: visible" class="title">
      <a
        :class="{
          'title-link': true,
          mobile: !isNotMobileOrSmall,
        }"
        :href="rootLink()"
      >
        <p class="mb-0" style="line-height: 1.125em">
          <span class="year">REDISTRICTING</span> &amp; YOU:
          <span class="nystext">{{$mainConfig.state["display-name"]}}</span>
        </p>
        <p class="text-caption mb-0">
          Comparing Post-2010 Districts with Post-2020 & Mid-Decade Districts
        </p>
      </a>
    </v-toolbar-title>
    <v-container fluid class="pa-0">
      <v-row class="ma-0">
        <!-- <v-col cols="12" sm="2" class="pa-0"> -->

        <!-- </v-col> -->
        <v-spacer></v-spacer>
        <v-col cols="6" class="px-0 py-1">
          <Modal v-show="isNotMobileOrSmall" />
        </v-col> 
        <v-col cols="4" class="pa-2">
          <AddressSearch v-show="isNotMobileOrSmall" />
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script>
import AddressSearch from "./AddressSearch.vue";
import Modal from "../Modal/Modal.vue";

export default {
  name: "TopMenuContainer",
  components: {
    AddressSearch,
    Modal,
  },
  data: function () {
    return {};
  },
  mounted: function () {
    // this.$router.push({ query: { plan: "private" } });
    // const query = { ...this.$route.query, someParam: "some-value" };
    // this.$router.replace({ query });
  },
  methods: {
    rootLink: function () {
      return window.location.origin + window.location.pathname;
    },
  },
  watch: {},
  computed: {
    isNotMobileOrSmall:function(){
      return this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm' && !this.$store.getters.isMobile;
    },
    buildType:function(){
      return this.$store.getters.getBuildType
    },
    showDev:function(){
      return this.$store.getters.getBuildType === 'development'
    }
  },
};
</script>
<style>
.title {
  cursor: pointer;
  font-weight: 900 !important;
  /* text-transform: uppercase; */
  cursor: default;
  color: var(--prussian-blue);
}

.title .year {
  color: var(--imperial-red);
  font-weight: 900 !important;
}

.title .nystext {
  color: black;
  font-weight: 500 !important;
}

.title-link {
  text-decoration: none;
  color: inherit !important;
}

.title-link.mobile {
  zoom: 75%;
}

.subtitle {
  font-size: 70%;
  text-transform: initial;
  font-weight: initial;
}

.dev-version{
      font-weight: 300;
    font-size: .75em;
    padding-left: 10px;
}
</style>
